module.exports = __webpack_public_path__ + "static/media/premium-products-square.c8f8a06e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/upgradeReason/premium-products-square.svg
// module id = 1517
// module chunks = 0